import React from "react"
import { Link, graphql } from "gatsby"
import Layout from "../components/Layout"
import Seo from "../components/Seo"
import { getPostImage } from "../data/blog-images"
import { formatBlogDate } from "../utils/formatBlogDate"

const BlogPage = ({ data }) => {
  const posts = data.allMarkdownRemark.nodes
    .map((node) => node.frontmatter)
    .filter((post) => post.published === true)

  return (
    <Layout bodyClass="blog archive">
      <Seo
        title="Blog"
        description="Read the latest articles about e-commerce feeds, product catalogs, and online marketing strategies."
        keywords={["blog", "e-commerce", "product feeds", "marketing"]}
        url="/blog/"
      />
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <h1 className="mb-4">Blog</h1>
            <p className="lead mb-5">
              Stay updated with the latest insights on e-commerce feeds, product catalogs, and digital marketing strategies.
            </p>
          </div>
        </div>
        
        <div className="row">
          {posts.map((post) => (
            <article key={post.id} className="col-md-6 col-lg-4 mb-5">
              <div className="card h-100 shadow-sm">
                {getPostImage(post) && (
                  <div className="card-img-top overflow-hidden" style={{ height: "200px" }}>
                    <img src={getPostImage(post)} alt={post.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                )}
                <div className="card-body d-flex flex-column">
                  <div className="mb-2">
                    <span className="badge bg-primary me-2">{post.category}</span>
                    <small className="text-muted">{formatBlogDate(post.date)}</small>
                  </div>
                  <h2 className="card-title h4">
                    <Link to={`/blog/${post.slug}`} className="text-decoration-none">
                      {post.title}
                    </Link>
                  </h2>
                  <p className="card-text flex-grow-1">{post.excerpt}</p>
                  <div className="mt-auto">
                    <Link 
                      to={`/blog/${post.slug}`} 
                      className="btn btn-primary"
                      aria-label={`Read more about ${post.title}`}
                    >
                      Read More →
                    </Link>
                    <div className="mt-2">
                      <small className="text-muted">{post.readingTime}</small>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default BlogPage

export const query = graphql`
  query BlogListingQuery {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        frontmatter {
          id
          slug
          title
          excerpt
          category
          date
          published
          readingTime
        }
      }
    }
  }
`
